const elements = {
  accordion: document.body.querySelectorAll('.js-accordion'),
  accordionTrigger: document.body.querySelectorAll('.js-accordion-trigger'),
};

function calcIndex(index, keyCode) {
  const calc = {
    38: (index - 1),
    40: (index + 1),
  };

  return calc[keyCode];
}

function keyHandler(e) {
  const accordion = this.closest('.js-accordion');

  if (accordion !== null) {
    const index = parseInt(this.dataset.index, 10);

    if ((e.keyCode === 38 && index > 0) ||
      (e.keyCode === 40 && index < parseInt(accordion.dataset.count - 1, 10))) {
      e.preventDefault();
      accordion.querySelectorAll('.js-accordion-trigger')[calcIndex(index, e.keyCode)].focus();
    }
  }
}

function getSiblings(elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  for (; sibling; sibling = sibling.nextSibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
  }
  return siblings;
}

function toggleVisibility() {
  const panelDiv = document.getElementById(this.getAttribute('aria-controls'));
  const prop = 'hidden';
  const active = 'is-active';

  const parent = this.closest('.c-accordion__item');
  const parentSiblings = getSiblings(parent);

  parentSiblings.forEach((parentSibling) => {
    const siblingTrigger = parentSibling.querySelector('.is-active');
    if (!siblingTrigger) {
      return;
    }

    const triggerTarget = document.getElementById(siblingTrigger.getAttribute('aria-controls'));
    triggerTarget[prop] = !triggerTarget[prop];
    siblingTrigger.classList.remove(active);
    siblingTrigger.setAttribute('aria-expanded', 'false');
  });

  this.classList.toggle(active);
  panelDiv[prop] = !panelDiv[prop];

  if (this.classList.contains(active)) {
    this.scrollIntoView({ behavior: 'smooth' });
  }

  if (this.getAttribute('aria-expanded') === 'false') {
    this.setAttribute('aria-expanded', 'true');
  } else {
    this.setAttribute('aria-expanded', 'false');
  }
}

function init() {
  if (elements.accordion.length && elements.accordionTrigger.length) {
    for (let i = 0; i < elements.accordionTrigger.length; i += 1) {
      elements.accordionTrigger[i].removeAttribute('disabled');
      elements.accordionTrigger[i].removeAttribute('title');
      elements.accordionTrigger[i].addEventListener('click', toggleVisibility);
      elements.accordionTrigger[i].addEventListener('keydown', keyHandler);
    }

    for (let i = 0; i < elements.accordion.length; i += 1) {
      const currentAccordion = elements.accordion[i];
      const items = currentAccordion.querySelectorAll('.js-accordion-item');

      for (let j = 0; j < items.length; j += 1) {
        const currentItem = items[j];
        const trigger = currentItem.querySelector('.js-accordion-trigger');
        trigger.setAttribute('aria-controls', `accordion-content-${i}-${j}`);
        trigger.setAttribute('data-index', i);
        currentItem.querySelector('.js-accordion-expand').id = `accordion-content-${i}-${j}`;
      }
    }
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/developers/accordion/mando-ui.accordion.js